import {ChartLegendWithAutoDropdown} from "common/ui/ChartLegends/ChartLegendWithAutoDropdownV3"
import { getGroupedSummaryData } from "../util/getSummaryData"
import { detectDataType } from "../util/detectDataType"


const summary_keys = ['total', 'count', 'average', 'high', 'low']

const getValueKeysData = (keys: string[], data?: Record<string, unknown>[], props?: Record<string, unknown>) => {
  
  const {
    colors
  } = props || {}

  let new_l = {}
  
  if (!data) return 

  if (keys) {
    console.log({keys})
    for (let i = 0; i < data.length; i++) {
      const item = data?.[i] as Record<string, unknown>
      keys.forEach((k) => {
        const group = k
        console.log({group})
        if (!new_l?.[group]) new_l = {...new_l, [group]: { group, total: 0, label_key: 'group', count: 0, average: 0, high: 0, low: 0, color: colors?.[group] } }
        const val = Number(item?.[k] || 0)
        new_l[group].total += val
        new_l[group].count += 1
        new_l[group].average = new_l[group].total / new_l[group].count
        if (val > new_l[group].high) new_l[group].high = val
        if (val < new_l[group].low) new_l[group].low = val
      })
    }
  }

  return Object.values(new_l)

}

export const ConfigurableLegend = ({
  legend_settings,
  legend_items,
  legendItems,
  keys,
  ...props
}: Record<string, unknown>): JSX.Element => {
 
  const {
    grouping_keys,
    grouping_key,
    color_key,
    data,
    value_key,
    value_keys,
    colors,
    checkIfSelected,
    checkIfFiltered,
    handleClick,
    format,
    selected,
    setSelected,
    data_type,
    axis_settings
  } = (props || {})

  let new_legend_settings = {} as Record<string, unknown>
  let legend_data = undefined
  const current_data_type = detectDataType(data as Record<string, unknown>[])
  keys = keys || grouping_keys || value_keys || ((axis_settings || {})?.left || {})?.keys
  
  if (current_data_type === 'summary') {
    new_legend_settings = {
      countKey: 'count',
      valueKey: legend_settings?.value_key || value_key || 'count',
      labelKey: grouping_key,
      colorKey: color_key || grouping_key,
    }
    legend_data =  data as Record<string, unknown>[]
  } else {
    if (data_type === 'inline') {
      
      if (keys) {
        const value_keys_data = getValueKeysData(keys, data, { colors})
        new_legend_settings = {
 
          groupKey: 'group',
          value_key: legend_settings?.value_key || 'count'
        }
        legend_data =  value_keys_data as Record<string, unknown>[]
      }
    }
  }

  legend_settings = {
    legendItems: legendItems || legend_items || legend_data,
    colors,
    selected,
    setSelected,
    checkIfSelected,
    checkIfFiltered,
    handleClick,
    format,
    ...(legend_settings || {}) as Record<string, unknown>,
    ...new_legend_settings,
    
  }
   
  return (
    <ChartLegendWithAutoDropdown {...legend_settings}/>
  )
}



export const ConfigurableLegendV1 = ({
  legend_settings,
  legend_items,
  legendItems,
  ...props
}: Record<string, unknown>): JSX.Element => {

  const {
    data, 
    auto_legend = true,
    data_type = 'inline',
    totals_key,
    value_keys,
    grouping_keys,
    colors,
    handleClick,
    checkIfSelected,
    checkIfFiltered,
  } = (props || {}) as Record<string, unknown> || {}

  const {
    count_key = props?.count_key,
    grouping_key = props?.grouping_key || legend_settings?.groupKey,
    color_key,
    value_key
  } = (legend_settings || {}) as Record<string, unknown> || {}

  if (auto_legend === false) return <></>

  legend_items = legend_items || legend_settings?.legend_items || legendItems

  let current_data_type = data_type

  if (!legend_items) {
  
    if (data?.[0]) {
      let count = 0
      Object.keys(data?.[0] || {}).forEach((k) => {
        if (summary_keys.includes(k)) count += 1
      })
      if (count > 2) current_data_type = 'summary'
    }
    
    if (data_type === 'inline' && current_data_type === 'summary') {
      legend_settings = {
        data_type: 'summary',
        value_key: value_key || 'total',
        totals_key: totals_key,
        grouping_key
      }
    }

  }

  legend_settings = {
    value_keys,
    grouping_key,
    grouping_keys,
    count_key,
    totals_key,
    checkIfFiltered,
    checkIfSelected,
    handleClick,
    legend_items: legend_items || legendItems,
    ...(legend_settings || {})
  }
 
 
  const summary_data = getGroupedSummaryData(
    data as Record<string, unknown>[] | undefined, {
    legend_settings
  })

  console.log({summary_data})
 
  if (data && !legend_settings?.legend_items) {
 
    if (data_type === 'inline') {

       let new_l = {}
  
       if (legend_settings?.value_keys) {
        for (let i = 0; i < data.length; i++) {
          const item = data?.[i] as Record<string, unknown>
          legend_settings.value_keys.forEach((k) => {
            const group = k
            if (!new_l?.[group]) new_l = {...new_l, [group]: { group, total: 0, count: 0, average: 0, high: 0, low: 0, color: colors?.[group] } }
            const val = Number(item?.[k] || 0)
            new_l[group].total += val
            new_l[group].count += 1
            new_l[group].average = new_l[group].total / new_l[group].count
            if (val > new_l[group].high) new_l[group].high = val
            if (val < new_l[group].low) new_l[group].low = val
          })
        }
  
        legend_settings = {
          legendItems:  Object.values(new_l),
          groupKey: 'group',
          valueKey: legend_settings?.value_key ||'count'
        }
       }
       
    
    }
  }

 
  return (
    <ChartLegendWithAutoDropdown {...legend_settings}/>
  )
}